import React from 'react';
import { ChatbotKeycloak } from './ChatbotKeycloak';
import { ChatbotOidc } from './ChatboxOidc';

interface ChatbotProps {
    excludedPaths?: string[];
    context: Record<string, unknown>;
    userId?: string;
    mercuryApiKey: string;
    mercuryCssUrl: string;
    oidc?: boolean;
    jestWorkerId?: string;
    children?: React.ReactNode;
}

export const Chatbot: React.FC<ChatbotProps> = ({
    oidc,
    excludedPaths,
    context,
    userId,
    mercuryApiKey,
    mercuryCssUrl,
    jestWorkerId,
}) => {
    if (oidc) {
        return (
            <ChatbotOidc
                excludedPaths={excludedPaths}
                context={context}
                userId={userId}
                mercuryApiKey={mercuryApiKey}
                mercuryCssUrl={mercuryCssUrl}
                jestWorkerId={jestWorkerId}
            />
        );
    } else {
        return (
            <ChatbotKeycloak
                excludedPaths={excludedPaths}
                context={context}
                userId={userId}
                mercuryApiKey={mercuryApiKey}
                mercuryCssUrl={mercuryCssUrl}
                jestWorkerId={jestWorkerId}
            />
        );
    }
};
